import { render, staticRenderFns } from "./ClinicianPatientFormWrapper.vue?vue&type=template&id=1faacece"
import script from "./ClinicianPatientFormWrapper.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientFormWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports